import React from 'react';
import styles from '../DashboardPage/DashboardPage.module.scss';
import { Outline } from '@otcmarketsgroup/otcm-ui';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';
import { HeadTitle } from '../../components/HeadTitle';
import { TabNav } from '../../components/TabNav';
import { MemoizedDashboardIdqsNmsGrids } from '../DashboardIdqsNmsGrids/DashboardIdqsNmsGrids';
import { MemoizedDashboardIdqsOvernightGrids } from '../DashboardIdqsOvernightGrids/DashboardIdqsOvernightGrids';
import { Button } from '../../components/Button';
import { PAGE_TAB_ITEMS } from '../../util/dashBoardPageConstants';

const TABLE_CONFIG_STORAGE_NAME = 'dashboard_overnight_trading_grid_pos';

class OvernightDashboardPage extends React.PureComponent {
  constructor (props) {
    super(props);
    this.state = {
      title: 'OverNight Dashboard',
      pauseRealTimeData: false,
      tableConfig: JSON.parse(window.localStorage.getItem(TABLE_CONFIG_STORAGE_NAME)) || ['idqs-night', 'idqs-nms']
    };
    this.pauseLiveData = this.pauseLiveData.bind(this);
    this.resumeLiveData = this.resumeLiveData.bind(this);
    this.renderChevRon = this.renderChevRon.bind(this);
  }

  pauseLiveData () {
    this.setState({
      pauseRealTimeData: true
    });
  }

  resumeLiveData () {
    this.setState({
      pauseRealTimeData: false
    });
  }

  renderGrid (i) {
    const tableConfig = this.state.tableConfig;
    if (tableConfig[i] === 'idqs-night') {
      return <div className={styles.idqsContainer}>
        <Outline
          mode='headingSmall'
          bottomBorderOnly={false}
          topBorderOnly={false}
          className={styles.contentHeader}
          content={this.renderChevRon(i)}
        >OTC</Outline><MemoizedDashboardIdqsOvernightGrids pauseRealTimeData={this.state.pauseRealTimeData} />
      </div>;
    } else if (tableConfig[i] === 'idqs-nms') {
      return <div className={styles.idqsContainer}>
        <Outline
          mode='headingSmall'
          bottomBorderOnly={false}
          topBorderOnly={false}
          className={styles.contentHeader}
          content={this.renderChevRon(i)}
        >NMS</Outline><MemoizedDashboardIdqsNmsGrids pauseRealTimeData={this.state.pauseRealTimeData} />
      </div>;
    }
  }

  renderTables () {
    const tableConfig = this.state.tableConfig;
    const _this = this;
    return tableConfig.map(function (item, index) {
      return <div key={'dashboard' + item}>{_this.renderGrid(index)}</div>;
    });
  }

  downGrid (i) {
    let tableConfig = [...this.state.tableConfig];
    let temp = tableConfig[i];
    tableConfig[i] = tableConfig[i + 1];
    tableConfig[i + 1] = temp;
    window.localStorage.setItem(TABLE_CONFIG_STORAGE_NAME, JSON.stringify(tableConfig));
    this.setState({ tableConfig: tableConfig }, this.renderTables);
  }

  upGrid (i) {
    let tableConfig = [...this.state.tableConfig];
    let temp = tableConfig[i];
    tableConfig[i] = tableConfig[i - 1];
    tableConfig[i - 1] = temp;
    window.localStorage.setItem(TABLE_CONFIG_STORAGE_NAME, JSON.stringify(tableConfig));
    this.setState({ tableConfig: tableConfig }, this.renderTables);
  }

  renderChevRon (pos) {
    const tableConfigSize = this.state.tableConfig.length;
    if (pos === 0) {
      return <FaArrowDown className={styles.slideArrowUp} onClick={() => this.downGrid(pos)} />;
    } else if (pos === tableConfigSize - 1) {
      return <FaArrowUp className={styles.slideArrowDown} onClick={() => this.upGrid(pos)} />;
    } else {
      return <div key={'arrowOptions'}>
        <FaArrowUp className={styles.slideArrowUp} onClick={() => this.upGrid(pos)} />
        <FaArrowDown className={styles.slideArrowDown} onClick={() => this.downGrid(pos)} />
      </div>;
    }
  }

  render () {
    return (
      <div key={'dashBoardPage'} >
        <HeadTitle title={this.state.title} />
        <div className={styles.tabControlsContainer}>
          <TabNav tabItems={PAGE_TAB_ITEMS} />
          <div className={styles.realTimeButton}>
            {!this.state.pauseRealTimeData && <Button title='Pause Live Data' onClick={this.pauseLiveData} size='extraSmall' />}
            {this.state.pauseRealTimeData && <Button title='Resume Live Data' onClick={this.resumeLiveData} size='extraSmall' /> }
          </div>
        </div>
        {this.renderTables()}
      </div>
    );
  }
}

export default OvernightDashboardPage;
